import { useBasketsTableColumns } from './use-table-columns';
import { useCallback, useContext, useEffect } from 'react';
import { BasketTableContext } from '../contexts/table';
import { useBackgroundNavigate, useSearchParams } from '@shared/hooks';
import { CountryContext } from '@modules/country';
import { SettingsContext } from '@modules/settings';
import { localURLMaker } from '@shared/utils';

export const useBasketsTable = () => {
  const navigate = useBackgroundNavigate();
  const { handleFetch, handleChangeFilterById } = useContext(BasketTableContext);
  const columns = useBasketsTableColumns();
  const [country] = useContext(CountryContext);
  const { searchParams, remove } = useSearchParams<{ reFetchBasketTable?: string }>();
  const { getCountryId } = useContext(SettingsContext);

  useEffect(() => {
    (async () => {
      if (searchParams.reFetchBasketTable) {
        remove.current('reFetchBasketTable');
        await handleFetch();
      }
    })();
  }, [handleFetch, remove, searchParams.reFetchBasketTable]);

  const getRowProps = useCallback(
    (id: string) => ({
      onDoubleClick: () => navigate(localURLMaker('/declarations', {}, { initialBasketId: id })),
    }),
    [navigate],
  );

  useEffect(() => {
    handleChangeFilterById('country_id', country.selected ? getCountryId(country.selected) : undefined);
  }, [handleChangeFilterById, country.selected, getCountryId]);

  return { columns, getRowProps };
};
